<script lang="ts">
  import '../../app.postcss'
  import TopBar from './components/TopBar.svelte'
  import { afterNavigate } from '$app/navigation'
  import { onDestroy, onMount } from 'svelte'
  import { writable } from 'svelte/store'
  import { fade, fly } from 'svelte/transition'
  import ButaneImage from '$lib/components/ButaneImage.svelte'

  let showModal = writable(false)

  const menuItems = [
    { icon: 'platform.png', title: 'Platform' },
    { icon: 'roadmap.png', title: 'Roadmap' },
    { icon: 'company.png', title: 'Company' },
    { icon: 'contact.png', title: 'Contact' },
  ]

  const socialIcons = [
    { icon: 'discord.png', alt: 'Discord', link: 'https://discord.gg/pxJah7qnnu' },
    { icon: 'telegram.png', alt: 'Telegram', link: 'https://t.me/butaneprotocol' },
    { icon: 'twitter.png', alt: 'Twitter', link: 'https://x.com/butaneprotocol' },
    { icon: 'forum.png', alt: 'Forum', link: 'https://forum.butane.dev/' },
  ]

  let ref: HTMLElement
  let portal: HTMLElement
  let reduceMotion = false

  afterNavigate((navigation) => {
    if (!navigation) return
    const { from, to, type } = navigation
    if (type !== 'popstate' && from && to && from.url.pathname !== to.url.pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
    }
  })

  onMount(() => {
    portal = document.createElement('div')
    portal.className = 'portal'
    document.body.appendChild(portal)

    if (ref) {
      portal.appendChild(ref)
    }
  })
  onMount(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const syncPreference = () => (reduceMotion = mediaQuery.matches)
    syncPreference()
    mediaQuery.addEventListener('change', syncPreference)
    return () => mediaQuery.removeEventListener('change', syncPreference)
  })
  onDestroy(() => {
    if (portal) {
      document.body.removeChild(portal)
    }
  })
</script>

{#if $showModal}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div bind:this={ref} class="fixed top-0 z-40 h-0 w-full">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
      class="fixed inset-0 z-10 bg-black bg-opacity-50 transition-all duration-500"
      onclick={() => ($showModal = false)}
      transition:fade={{ duration: reduceMotion ? 0 : 500 }}
    ></div>
    <div
      class="relative z-20 flex h-svh flex-col bg-black transition-all duration-300 ease-in-out
      md:mx-auto md:mt-5 md:h-[586px] md:w-[95vw] md:max-w-[1322px] md:rounded-[60px] md:border md:border-[#272D37]"
      transition:fly={{ y: reduceMotion ? 0 : -50, duration: reduceMotion ? 0 : 500 }}
    >
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div class="ml-auto mr-5 mt-5 items-center justify-center md:mx-auto">
        <svg class="h-[32px] w-[52px] cursor-pointer" onclick={() => ($showModal = false)} inline-src="close-modal" />
      </div>
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="my-auto flex flex-col justify-center md:flex-row">
        {#each menuItems as item}
          <div class="mx-[20px] mt-6 flex w-auto flex-row items-center md:flex-col md:gap-8">
            <ButaneImage
              src={item.icon}
              width={96}
              height={96}
              alt={item.title}
              class="h-[64px] w-[64px] md:h-[96px] md:w-[96px]"
            />
            <h3 class="ml-3 mt-3 font-graphik text-3xl font-light">{item.title}</h3>
            <a
              href="/{item.title.toLowerCase()}"
              aria-label={item.title}
              class="ml-auto md:ml-0"
              onclick={() => ($showModal = false)}
            >
              <svg width="57" height="32" viewBox="0 0 57 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" width="56" height="32" rx="16" fill="#FF723A" />
                <path
                  d="M29.9471 8.94705L36.9097 16L29.947 23.053L28.9026 21.995L34.0423 16.7886H20.7886L20.7886 15.2114L34.0423 15.2114L28.9027 10.005L29.9471 8.94705Z"
                  fill="#050505"
                />
              </svg>
            </a>
          </div>
        {/each}
      </div>
      <div class="mx-auto mb-[53px] flex h-[33px] w-[230px] flex-row items-center justify-center gap-6">
        {#each socialIcons as { icon, alt, link }}
          <a href={link} target="_blank" rel="noreferrer" aria-label={alt}>
            <ButaneImage src={icon} layout="fixed" width={32} height={32} {alt} />
          </a>
        {/each}
      </div>
    </div>
  </div>
{/if}

<TopBar class="z-[2]" menu={() => ($showModal = true)} />
<main id="company">
  <slot />
</main>

<style lang="postcss">
  :global(body) {
    @apply bg-black p-0 text-white;
  }
</style>
